import {
    CloseCircleOutlined,
    DownloadOutlined,
    DownOutlined,
    InfoCircleOutlined,
    PlusOutlined,
    UpOutlined
} from '@ant-design/icons';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import TuneIcon from "@mui/icons-material/Tune";
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import {
    Button as MuiButton,
    CssBaseline,
    Grid,
    IconButton,
    IconButton as MuiIconButton,
    Stack,
    ThemeProvider
} from "@mui/material";
import {
    Button,
    Col,
    Empty,
    message,
    Pagination,
    Row,
    Select,
    Spin,
    Table,
    Tag,
    Tooltip,
    Typography,
} from 'antd';
import axios from "axios";
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {getCaseNamePlaceholder} from 'utils/org_utils';
import '../asset/style/custom_antd_table_style.css';
import '../asset/style/case_view.css';
import FilterComp from "../component/case/filter";
import {caseInfoApp} from "../component/gammaviewer/app_maker";
import {morphleTheme1} from "../component/gammaviewer/themes";
import ShareModal from "../component/utils/shareModal";
import {delete_, get_pdf, get_response} from "../helper/request";
import {
    caseUpdateAlert,
    deleteCase,
    loadCasePriorities,
    loadCases,
    markCaseRead,
    markCaseUnread,
    removeUserUpdateAlert
} from '../redux_actions/cases.action';
import {Redirect} from "react-router-dom";
import {makeMenuVisible} from "../redux_actions/context.menu.action";
import {loadMorpheusSetting, updateSort} from "../redux_actions/morpheus.setting.action";
import {
    changeOrdering,
    changePage,
    clearAllFilters,
    updateCaseSearch,
    updateUrlStateInReducer
} from '../redux_actions/search.case.action';
import {addCasesToShare} from "../redux_actions/shareManager.action";
import {getNewState, getNewStatePreserveOrdering} from "../redux_reducers/search.case.reducer";
import {caseArchiveStatusEnum, caseReadStatusEnum, openInNewTabType} from '../utils/const';
import {isNull, isTrue, linkViewerRedirect, notNull, openEndPoint, openEndPointRedirect} from "../utils/utils";
import {error_manager} from "../helper/error_manager";
import {getAssignedNamesComponent} from "../component/case/case_utils";
import {performAbortControllerCaseSearch} from "../utils/api";

const Option = Select.Option;


class CasesView extends Component {
    constructor(props) {
        super(props);

        this.divFullParentRef = React.createRef();
        this.divHeaderRef = React.createRef();
        this.selectOrderingRef = React.createRef();
        this.divBodyRef = React.createRef();
        this.divPaginationRef = React.createRef();
        this.unreadTableHeadingRef = React.createRef();
        this.everythingElseTableHeadingRef = React.createRef();

        this.state = {
            selectedRowKeys: [],
            searchTerm: this.props.urlState.search,
            initializationDone: false,
            case_status: -1,
            priority: 'Set Priority',
            anchorEl: null,
            filtersApplied: false,
            isUnreadTableCollapsed: false,
            isEverythingElseTableCollapsed: false,
            redirect: null,
            caseSuggestions: [],
            loadingCaseSearchResults: false
        }

        this.assignCasePerm = hasPermissions([aclPermissions.assign_case])
        this.viewCaseDetailPerm = hasPermissions([aclPermissions.view_case_details])
    }

    componentDidMount = () => {
        let defaultUrlState = getNewState()
        let newUrlState = this.props.urlState
        newUrlState['read_status'] = this.props.caseViewFilter['read_status'] ? this.props.caseViewFilter['read_status'] : defaultUrlState.read_status
        newUrlState['priority'] = this.props.caseViewFilter['priority'] ? this.props.caseViewFilter['priority'] : defaultUrlState.priority
        newUrlState['case_status'] = this.props.caseViewFilter['case_status'] ? this.props.caseViewFilter['case_status'] : defaultUrlState.case_status
        newUrlState['archive_status'] = this.props.caseViewFilter['archive_status'] ? this.props.caseViewFilter['archive_status'] : defaultUrlState.archive_status
        newUrlState['page'] = this.props.caseViewFilter['page'] ? this.props.caseViewFilter['page'] : defaultUrlState.page
        newUrlState['case_assigned'] = this.props.caseViewFilter['assigned_to_me'] ? this.props.caseViewFilter['assigned_to_me'] : defaultUrlState.case_assigned
        newUrlState['ordering'] = this.props.caseOrder
        newUrlState['validation_id'] = ''
        this.props.dispatch(updateUrlStateInReducer(newUrlState));
        this.props.dispatch(loadCasePriorities());
    }

    getCases = (cases) => {
        let newData = []
        Object.keys(cases).sort(
            function (a, b) {
                return cases[a].displayOrder - cases[b].displayOrder;
            }
        ).forEach((key) => {
            let curr = cases[key];
            curr.key = curr.id;
            curr.case = this.getCaseDesign(curr);
            curr.type = openInNewTabType.CASE;
            newData.push(curr);
        });
        return newData;
    }

    getCaseDesign = (caseInfo) => {

        const isArchived = isTrue(caseInfo.archive_status)

        const dateElement = (
            caseInfo.unread ?
                <b>{caseInfo.date}</b> :
                <span>{caseInfo.date}</span>
        )

        const isLongCaseID = caseInfo.case_id.length > 15;
        const caseIdElem = (
            caseInfo.unread ?
                <b className={'preserve-white-space'}>{isLongCaseID ? `${caseInfo.case_id.slice(0, 15)}...` : caseInfo.case_id}</b> :
                <span className={'preserve-white-space'}>{isLongCaseID ? `${caseInfo.case_id.slice(0, 15)}...` : caseInfo.case_id}</span>
        );
        const finalCaseIdElem = isLongCaseID ?
            <Tooltip title={caseInfo.case_id} key={caseInfo.case_id}>{caseIdElem}</Tooltip> : caseIdElem;

        const isLongName = caseInfo.patient_name && caseInfo.patient_name.length > 25;
        const nameElem = (
            caseInfo.unread ?
                <b>{isLongName ? `${caseInfo.patient_name.slice(0, 25)}...` : caseInfo.patient_name}</b> :
                <span>{isLongName ? `${caseInfo.patient_name.slice(0, 25)}...` : caseInfo.patient_name}</span>
        );
        const finalNameElem = isLongName ?
            <Tooltip title={caseInfo.patient_name} key={caseInfo.patient_name}>{nameElem}</Tooltip> : nameElem;

        const isLongStatus = caseInfo.case_status?.length > 35;
        const statusElem = [
            <Tag onClick={(event) => event.stopPropagation()} color={isArchived ? "lightgray" : null}>{isArchived ? "Archived" : "Inbox"}</Tag>,
            caseInfo.case_status ? <Tag key={caseInfo.case_id} color={isArchived ? null : "purple"} onClick={(event) => event.stopPropagation()}>
                {isLongStatus ? `${caseInfo.case_status?.slice(0, 35)}...` : caseInfo.case_status}
            </Tag> : null
        ];
        const finalStatusElem = isLongStatus ?
            <Tooltip title={caseInfo.case_status} key={caseInfo.case_status}>{statusElem}</Tooltip> : statusElem;
        const priorityElem = caseInfo.priority

        const assigned_names = getAssignedNamesComponent(caseInfo, isArchived);

        const slide_count = caseInfo.unread ? <b>{caseInfo.slide_count}</b> : <span>{caseInfo.slide_count}</span>

        const assignUserButton = this.assignCasePerm ? <Tooltip title={"Assign To Users"}><IconButton><AssignmentIndOutlinedIcon /></IconButton></Tooltip> : null

        const openCaseDetailPageButton = this.viewCaseDetailPerm ? <Tooltip title={`${getCaseNamePlaceholder()} Details`}><IconButton><DescriptionIcon /></IconButton></Tooltip> : null

        const isUnreadSectionCase = notNull(caseInfo.days_unread_since)
        const unreadSinceDaysBadge = caseInfo.show_unread_warning ? (
            <Tooltip title={`Unread since ${caseInfo.days_unread_since} days`}>

                <div style={{
                    width: '80%',
                    height: '100%',
                    borderRadius: '4px',
                    color: '#f5222d',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#fff1f0',
                    marginLeft: 'auto',
                    boxShadow: '0 0 5px rgba(245, 34, 45, 0.2)',
                }}>
                    {caseInfo.days_unread_since}
                </div>
            </Tooltip>
        ) : null;

        return <Row style={{ display: 'flex', alignItems: 'center' }}>
            <Col span={2}>
                {dateElement}
            </Col>
            <Col span={4}>
                {finalCaseIdElem}
            </Col>
            <Col span={4}>
                {finalNameElem}
            </Col>
            <Col span={4}>
                {finalStatusElem}
            </Col>
            <Col span={2}>
                {priorityElem}
            </Col>
            {isUnreadSectionCase ? (
                <Col span={4}>
                    {assigned_names}
                </Col>
            ):(
                <Col span={5}>
                    {assigned_names}
                </Col>
            )}

            <Col span={1}>
                {slide_count}
            </Col>
            {isUnreadSectionCase && (
                <Col span={1}>
                    {unreadSinceDaysBadge}
                </Col>
            )}
            <Col span={1} style={{ display: 'flex', justifyContent: 'flex-end' }} onClick={(e) => {
                e.stopPropagation();
                this.caseRefreshProps = [caseInfo];
                this.props.dispatch(addCasesToShare(caseInfo.id))
            }}>
                {assignUserButton}
            </Col>
            <Col span={1} style={{ display: 'flex', justifyContent: 'flex-end' }} onClick={(e) => {
                e.stopPropagation();
                let redirectUrl=this.linkCaseRedirect(e, caseInfo, true)
                if(notNull(redirectUrl)){
                    this.setState({
                        redirect: redirectUrl
                    })
                }
            }}>
                {openCaseDetailPageButton}
            </Col>
        </Row>
    }

    handleCancelAssignedUser = (event, currCase, user_id) => {
        event.stopPropagation();

        let val = {
            id: currCase.id,
            case_id: currCase.case_id,
            displayOrder: currCase.displayOrder,
            user_id: user_id
        };
        this.props.dispatch(removeUserUpdateAlert(currCase.id, val, this.props.urlState));
    }

    generateReport = () => {
        let url = `/api/get_pdf/?case_id=${this.state.selectedCase.case_id}`;
        get_pdf(url)
    }

    initializeSearch = () => {
        if (!this.state.initializationDone && this.props.urlState.search.length > 0) {
            this.setState({
                searchTerm: this.props.urlState.search,
                initializationDone: true,
            })
        }
    }

    onCaseSearch = (e) => {
        this.setState({
            selectedRowKeys: [],
        })
        this.props.dispatch(updateCaseSearch(e.target.value, this.props.urlState));
    }

    onInputChange = (value) => {
        this.setState({
            selectedRowKeys: [],
            caseSuggestions: [],
            searchTerm: value,
        });
        this.props.dispatch(updateCaseSearch(value, this.props.urlState));
    }

    clearSearch = () => {
        this.setState({
            selectedRowKeys: [],
            searchTerm: '',
        });
        this.props.dispatch(updateCaseSearch('', this.props.urlState));
    }

    onSeachReset = () => {
        let searchTerm = '';
        this.setState({
            searchTerm,
            selectedRowKeys: [],
            caseSuggestions: [],
        });
        this.props.dispatch(clearAllFilters());
    }

    getStatusOptions = () => {
        let status_options = Object.keys(this.props.allCaseStatus).map((key) => {
            let value = this.props.allCaseStatus[key];
            return <Option key={value.id} value={value.id}>{value.status}</Option>
        });
        status_options.unshift(<Option value={-1} key={-1}>Set Status</Option>);
        return status_options;
    }

    getPriorityOptions = () => {
        let priority_options = this.props.casePriorities.map((priority_obj) => {
            return <Option value={priority_obj?.id}>{priority_obj?.name}</Option>
        });
        priority_options.unshift(<Option value={"Set Priority"} key={-1}>Set Priority</Option>);
        return priority_options;
    }

    allUnreadCases = (selectedCases) => {
        for (let i = 0; i < selectedCases.length; i++) {
            if (this.props.allCases[selectedCases[i]].unread) {
                return false;
            }
        }
        return true;
    }

    makeCasesUnread = () => {
        const is_unread_first = this.props.urlState?.ordering === "unread_first_everything_else";

        if(is_unread_first){
            const selectedCases = this.state.selectedRowKeys.map(value => this.props.allCases[value]);
            this.unreadFirstMarkCasesUnreadAsync(selectedCases);
        }else{
            this.state.selectedRowKeys.forEach((value) => {
                let curr_case = this.props.allCases[value];
                this.props.dispatch(markCaseUnread(curr_case));
            });
        }
    }

    makeCasesRead = () => {
        const is_unread_first = this.props.urlState?.ordering === "unread_first_everything_else";

        if(is_unread_first){
            const selectedCases = this.state.selectedRowKeys.map(value => this.props.allCases[value]);
            this.unreadFirstMarkCasesReadAsync(selectedCases)
        }else{
            this.state.selectedRowKeys.forEach((value) => {
                let curr_case = this.props.allCases[value];
                this.props.dispatch(markCaseRead(curr_case));
            });
        }
    }

    unreadFirstMarkCasesUnreadAsync = async (cases) => {
        const promises = cases.map(curr_case => {
            return new Promise((resolve,reject) => {
                let url = `/api/make_case_unread/?case_id=${curr_case.id}`;
                get_response(url)
                    .then(response => {
                        resolve();
                    })
                    .catch(err => {
                        reject();
                    });
            });
        });

        await Promise.all(promises);

        this.setState({
            selectedRowKeys: [],
        });

       this.props.dispatch(loadCases(this.props.urlState, true, this.state.isUnreadTableCollapsed,this.calculateMaxRows()));
    };

    unreadFirstMarkCasesReadAsync = async (cases) => {
        const promises = cases.map(curr_case => {
            return new Promise((resolve,reject) => {
                let url = `/api/make_case_read/?case_id=${curr_case.id}`;
                get_response(url)
                    .then(response => {
                        resolve();
                    })
                    .catch(err => {
                        reject();
                    });
            });
        });

        await Promise.all(promises);

        this.setState({
            selectedRowKeys: [],
        });

        this.props.dispatch(loadCases(this.props.urlState, true, this.state.isUnreadTableCollapsed, this.calculateMaxRows()));

    };

    assignMultipleCases = (e) => {
        e.stopPropagation();
        let case_ids = []
        let cases = []
        this.state.selectedRowKeys.forEach((value) => {
            case_ids.push(this.props.allCases[value].id);
            cases.push(this.props.allCases[value]);
        });
        this.caseRefreshProps = cases;
        this.props.dispatch(addCasesToShare(case_ids))
    }

    deleteMultipleCases = (e) => {
        e.stopPropagation();
        const selectedCaseKeys = this.state.selectedRowKeys;
        const caseIdsToDelete = selectedCaseKeys.map(key => this.props.allCases[key].id);

        // Clear selected rows as they will create issues when data gets cleared
        this.setState({ selectedRowKeys: [] })

        const deleteRequests = caseIdsToDelete.map(caseId =>
            delete_(`/api/case/${caseId}/`)
        );
        axios.all(deleteRequests)
            .then(axios.spread(() => {
                selectedCaseKeys.map(key => this.props.dispatch(deleteCase(key)))
                message.success("All cases deleted successfully");
            }))
            .catch(err => {
                error_manager("Failed to delete cases", err)
            });
    }

    getRowActionsIfAtleastOneRowSelected = () => {

        if (this.state.selectedRowKeys.length <= 0) {
            return null
        }

        return <Grid container>
            <Grid item xs={7}>
                <Stack direction={"row"} justifyContent={"flex-start"} spacing={2}>
                    <MuiButton variant={"outlined"} color={"buttonPrimary"} size={"small"}
                        onClick={() => {
                            this.setState({ selectedRowKeys: [] })
                        }}>
                        Cancel Selection
                    </MuiButton>
                    <Tooltip placement="top" title={"Mark Unread"}><MuiIconButton color={"buttonPrimary"} size={"small"}
                        onClick={this.makeCasesUnread}>
                        <MarkunreadOutlinedIcon />
                    </MuiIconButton>
                    </Tooltip>
                    <Tooltip placement="top" title={"Mark Read"}><MuiIconButton color={"buttonPrimary"} size={"small"}
                        onClick={this.makeCasesRead}>
                        <DraftsOutlinedIcon />
                    </MuiIconButton>
                    </Tooltip>
                    {this.assignCasePerm && <Tooltip placement="top" title={"Assign to Users"}>
                        <MuiIconButton color={"buttonPrimary"} size={"small"}
                            onClick={this.assignMultipleCases}>
                            <AssignmentIndOutlinedIcon />
                        </MuiIconButton>
                    </Tooltip>}
                    <Tooltip placement="top" title={"Archive Folders & Slides"}>
                        <MuiIconButton color={"buttonPrimary"} size={"small"}
                            onClick={() => this.archiveCases(true)}>
                            <ArchiveOutlinedIcon />
                        </MuiIconButton>
                    </Tooltip>
                    <Tooltip placement="top" title={"UnArchive Folders & Slides"}>
                        <MuiIconButton color={"buttonPrimary"} size={"small"}
                            onClick={() => this.archiveCases(false)}>
                            <UnarchiveOutlinedIcon />
                        </MuiIconButton>
                    </Tooltip>
                    <Tooltip placement="top" title={"Delete Folders"}>
                        <MuiIconButton color={"buttonPrimary"} size={"small"}
                            onClick={this.deleteMultipleCases}>
                            <DeleteOutlinedIcon />
                        </MuiIconButton>
                    </Tooltip>
                </Stack>
            </Grid>
            <Grid item xs={5}>
                <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
                    <Select
                        value={this.state.case_status}
                        placeholder="Select Status"
                        onChange={this.handleTypeChange}
                        style={{ width: 220 }}
                    >
                        {this.getStatusOptions()}
                    </Select>
                    <Select
                        value={this.state.priority}
                        placeholder="Set Priority"
                        onChange={this.handlePriorityChange}
                        style={{ width: 120 }}
                    >
                        {this.getPriorityOptions()}
                    </Select>
                    <MuiButton variant={"outlined"} color={"buttonPrimary"} size={"small"}
                        onClick={this.sumitUsersAndStatus}
                        disabled={this.state.case_status === -1 && this.state.priority === 'Set Priority'}>
                        Submit
                    </MuiButton>
                </Stack>
            </Grid>
        </Grid>
    }

    handleSortChange = (value) => {
        this.props.dispatch(changeOrdering(value, this.props.urlState, this.state.isUnreadTableCollapsed));
        this.props.dispatch(updateSort({ case_order_by: value }));
    }

    handleTypeChange = (status) => {
        this.setState({
            case_status: status,
        });
    }

    handlePriorityChange = (value) => {
        this.setState({
            priority: value
        })
    }

    sumitUsersAndStatus = () => {
        this.state.selectedRowKeys.forEach((value) => {
            this.handleChangeStatusAndPriority(this.props.allCases[value], this.state.case_status, this.state.priority, this.state.selectedRowKeys);
        });

        this.setState({
            selectedRowKeys: [],
            case_status: -1,
            priority: 'Set Priority',
        })
    }

    handleChangeStatusAndPriority = (currCase, inputStatus, inputPriority, selectedRows) => {
        let val = {
            case_id: currCase.case_id,
            displayOrder: currCase.displayOrder,
        };
        if (this.state.case_status !== -1) {
            val['case_status_id'] = inputStatus;
        }
        if (this.state.priority !== "Set Priority") {
            val['priority_id'] = inputPriority
        }
        this.props.dispatch(caseUpdateAlert(currCase.id, val, selectedRows, true));
    };

    archiveCases = (willArchive) => {
        this.state.selectedRowKeys.forEach((value) => {
            this.handleChangeArchiveStatus(this.props.allCases[value], willArchive, this.state.selectedRowKeys);
        });

        this.setState({selectedRowKeys: []})
    }

    handleChangeArchiveStatus = (currCase, input, selectedRows) => {
        let val = {
            case_id: currCase.case_id,
            displayOrder: currCase.displayOrder,
            change_slide_archive_status: true,
            archive_status: input
        };
        this.props.dispatch(caseUpdateAlert(currCase.id, val, selectedRows, true));
    };

    getPaginationDiv = () => {
        return <Pagination
            total={this.props.total}
            showTotal={(total, range) =>
                this.isMobile ? `` : `Showing ${range[0]}-${range[1]} out of ${total} total cases`
            }
            current={this.props.urlState.page}
            pageSize={this.props.urlState.page_size}
            defaultCurrent={1}
            onChange={this.updatePage}
            size="small"
            className="pagination-mp"
        />
    }

    updatePage = (pageNumber) => {
        this.props.dispatch(changePage(pageNumber, this.props.urlState));
    }

    linkCaseRedirect = (e, record, open_detail_page) => {
        if (open_detail_page || isNull(record.first_slide_meta)) {
            return openEndPointRedirect("/case/" + record.id, e.ctrlKey || e.metaKey, false);
        } else {
            return linkViewerRedirect(record.first_slide_meta, `??topApp=${caseInfoApp.id}`, e.ctrlKey || e.metaKey)
        }
    }

    openAddNewCase = () => {
        openEndPoint("/addcase/", false, true);
    }

    handleFilterPane = () => {
        const searchBarCase = document.getElementById("search-bar-case");
        this.searchBarWidth = notNull(searchBarCase?.offsetWidth) ? searchBarCase?.offsetWidth : -1
        this.setState({ anchorEl: isNull(this.state.anchorEl) ? searchBarCase : null })
    }

    onCaseFilterClose = () => {
        this.setState({ anchorEl: null })
    }

    getFiltersList = () => {
        let searchValuesFilter = []
        const urlState = this.props.urlState;

        if (isTrue(urlState.case_assigned)) {
            searchValuesFilter.push(['case_assigned', 'Assigned To Me']);
        }
        if (urlState.priority !== '') {
            let prio = this.props.casePriorities.find((value) => {
                return value.id === urlState.priority
            })
            searchValuesFilter.push(['priority', "Priority = " + prio?.name]);
        }
        if (urlState.case_status !== '') {
            let status = Object.values(this.props.allCaseStatus).find((value) => {
                return value.id === urlState.case_status
            })
            searchValuesFilter.push(["case_status", "Status = " + status?.status]);
        }
        if (urlState.date__gte !== '' || urlState.date__lte !== '') {
            searchValuesFilter.push(["date", ('Date = ' + urlState.date__gte) + ("/") + (urlState.date__lte)]);
        }
        if (urlState.read_status !== caseReadStatusEnum.ALL) {
            let text = Object.entries(caseReadStatusEnum).find(([key, value], index) => {
                return value === urlState.read_status
            })
            if (text && text.length > 0) {
                searchValuesFilter.push(["read_status", text[0]]);
            }
        }
        if (urlState.archive_status !== caseArchiveStatusEnum.UNARCHIVED) {
            let text = Object.entries(caseArchiveStatusEnum).find(([key, value], index) => {
                return value === urlState.archive_status
            })
            if (text && text.length > 0) {
                searchValuesFilter.push(["archive_status", text[0] + " Folders"]);
            }
        }

        if (this.state.filtersApplied && searchValuesFilter.length === 0) {
            this.setState({ filtersApplied: searchValuesFilter.length > 0 })
        } else if (!this.state.filtersApplied && searchValuesFilter.length > 0) {
            this.setState({ filtersApplied: searchValuesFilter.length > 0 })
        }

        return searchValuesFilter
    }

    clearFilter = (e, key) => {
        e.preventDefault();
        e.stopPropagation();
        let urlState = this.props.urlState;
        const newUrlState = getNewStatePreserveOrdering();
        if (key === "date") {
            key = "date__gte"
            urlState[key] = newUrlState[key];
            key = "date__lte"
            urlState[key] = newUrlState[key];
        } else {
            urlState[key] = newUrlState[key];
        }

        const is_unread_first = this.props.urlState?.ordering === "unread_first_everything_else";
        if(is_unread_first){
            setTimeout(() => this.props.dispatch(loadCases(this.props.urlState, true, this.state.isUnreadTableCollapsed, this.calculateMaxRows())), 100)
        }else{
            setTimeout(() => this.props.dispatch(loadCases(urlState)), 100);
        }
    }

    getFilterTags = () => {
        this.filtersValues = this.getFiltersList();
        let retObj = []
        if (this.filtersValues.length > 0) {
            retObj.push(<Typography style={{ marginRight: 10, width: 'fit-content' }}>Applied Filters</Typography>)
        }
        this.filtersValues.forEach((value, index) => {
            retObj.push(<Tag key={index} bordered={false} color={"purple"} closable
                onClose={(e) => this.clearFilter(e, value[0])}>{value[1]}</Tag>)
        })
        return retObj;
    }

    exportToJSON = (data) => {
        if (data.length === 0) {
            message.info("No Folder Available");
            return;
        }
        const link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob(
            [[Object.keys(data[0]).join(), ...data].reduce((res, json) =>
                `${res}\n${['', ...Object.keys(json)].reduce((res, key) =>
                    `${res}"${typeof json[key] === 'object' ?
                        JSON.stringify(json[key]).split(`"`).join('') :
                        json[key]}",`)}`)],
            {
                type: 'text/csv',
            }
        ))
        link.download = `case_data.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    fetchCases = () => {
        let url = `/api/export_pdf_cases/`;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.length === 0) {
                        message.warn("No Folders found")
                    } else {
                        this.exportToJSON(response.data)
                    }
                }
            })
            .catch((err) => {
                error_manager("Folders Summary download failed", err)
            })
    }

    handleToggleUnreadTableCollapse = () => {
        this.props.dispatch(loadCases(this.props.urlState, true, !this.state.isUnreadTableCollapsed, this.calculateMaxRows()));
        this.setState((prevState) => ({
            isUnreadTableCollapsed: !prevState.isUnreadTableCollapsed,
        }));
    };

    handleToggleEverythingElseTableCollapse = () => {
        this.setState((prevState) => ({
            isEverythingElseTableCollapsed: !prevState.isEverythingElseTableCollapsed,
        }));
    };

    calculateMaxRows = () => {
        // let divFullParentHeight = this.divFullParentRef.current.clientHeight;
        const divFullParentHeight = window.innerHeight

        const screenPaddingTopHeight = 30
        const divHeaderHeight = this.divHeaderRef.current.clientHeight;
        const marginBelowHeaderHeight = 25

        const selectOrderingHeight = this.selectOrderingRef.current.clientHeight;

        const unreadTableHeadingHeight = this.unreadTableHeadingRef.current.clientHeight;
        const everythingElseTableHeadingHeight = this.everythingElseTableHeadingRef.current.clientHeight;
        const tableHeaderHeight = 60
        const screenPaddingBottomHeight = 10

        const divBody = this.divBodyRef.current.clientHeight;

        const divPaginationHeight = this.divPaginationRef.current.clientHeight;

        const leaveSpaceForMisc = 70
        const tableRowHeight = 48

        const heightTakenByOtherComponents = (screenPaddingTopHeight + divHeaderHeight + marginBelowHeaderHeight + selectOrderingHeight + unreadTableHeadingHeight + everythingElseTableHeadingHeight + screenPaddingBottomHeight + divPaginationHeight + leaveSpaceForMisc)
        const heightAvailableForTable = divFullParentHeight - heightTakenByOtherComponents

        const maxRowsAvailable = Math.floor(heightAvailableForTable / tableRowHeight)

        return maxRowsAvailable
      };

    updateCaseSearchResults = (searchResults) => {
        this.setState({
            loadingCaseSearchResults: false,
            caseSuggestions: searchResults,
        })
    }

    performCaseSearch = (value) => {
        this.setState({
            loadingCaseSearchResults: true,
            searchTerm: value,
        })
        performAbortControllerCaseSearch(value, this.updateCaseSearchResults)
    }

    render() {
        this.initializeSearch();
        let data = [];
        let unreadFirstDataTable = [];
        if (this.props.urlState?.ordering === "unread_first_everything_else") {
            const casesWithWarning = {};
            const casesWithoutWarning = {};

            Object.keys(this.props.allCases).forEach(key => {
                const currentCase = this.props.allCases[key];

                if ('days_unread_since' in currentCase) {
                    casesWithWarning[key] = currentCase;
                } else {
                    casesWithoutWarning[key] = currentCase;
                }
            });

            unreadFirstDataTable = this.getCases(casesWithWarning);
            data = this.getCases(casesWithoutWarning);
        }else{
            data = this.getCases(this.props.allCases);
        }

        let columns = [
            {
                title: () => {
                    return <Row>
                        <Col span={2}>
                            <b>DATE</b>
                        </Col>
                        <Col span={4}>
                            <b>FOLDER NAME</b>
                        </Col>
                        <Col span={4}>
                            <b>PATIENT'S NAME</b>
                        </Col>
                        <Col span={4}>
                            <b>STATUS</b>
                        </Col>
                        <Col span={2}>
                            <b>PRIORITY</b>
                        </Col>
                        <Col span={5}>
                            <b>ASSIGNED USERS</b>
                        </Col>
                        <Col span={1}>
                            <b>SLIDES</b>
                        </Col>
                        <Col span={2}>

                        </Col>
                    </Row>
                },
                dataIndex: "case",
                key: "case",
            }
        ]

        let unreadFirstColumns = [
            {
                title: () => {
                    return <Row>
                        <Col span={2}>
                            <b>DATE</b>
                        </Col>
                        <Col span={4}>
                            <b>FOLDER NAME</b>
                        </Col>
                        <Col span={4}>
                            <b>PATIENT'S NAME</b>
                        </Col>
                        <Col span={4}>
                            <b>STATUS</b>
                        </Col>
                        <Col span={2}>
                            <b>PRIORITY</b>
                        </Col>
                        <Col span={4}>
                            <b>ASSIGNED USERS</b>
                        </Col>
                        <Col span={1}>
                            <b>SLIDES</b>
                        </Col>
                        <Col span={1}>

                        </Col>
                        <Col span={2}>

                        </Col>
                    </Row>
                },
                dataIndex: "case",
                key: "case",
            }
        ]

        const onRow = (record, rowIndex) => {
            return {
                onClick: event => {
                    let redirectUrl=this.linkCaseRedirect(event, record, false)
                    if(notNull(redirectUrl)){
                        this.setState({
                            redirect: redirectUrl
                        })
                    }
                },
                onContextMenu: (event) => {
                    event.preventDefault();
                    this.props.dispatch(makeMenuVisible({
                        visible: true,
                        x: event.clientX,
                        y: event.clientY,
                        record: record,
                        height: this.props.height
                    }));
                }
            };
        }

        if(this.state.redirect){
            window.history.pushState('', 'cases', window.location.href)
            return <Redirect to={this.state.redirect}/>
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            },
            selectedRowKeys: this.state.selectedRowKeys,
            columnWidth: '10px',

        };

        let numSuggested = this.state.caseSuggestions.length;

        let caseSuggestionsBox = ( numSuggested > 0 || this.state.loadingCaseSearchResults ) ? (
            <Select.OptGroup label={this.state.loadingCaseSearchResults ?
                <div><Spin size="small"/> <span style={{marginLeft: 5}}>{" Loading results... "}</span></div> :
                <div><b>{numSuggested}</b> result{numSuggested > 1 ? 's' : ''} found </div>}>
                {(this.state.searchTerm.length > 0 && this.state.caseSuggestions.findIndex((item) => this.state.searchTerm.toUpperCase() === item.display_text.toUpperCase())=== -1) &&
                    <Select.Option
                        key={-1}
                        value={this.state.searchTerm}
                        label={this.state.searchTerm}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        <span className={'preserve-white-space'}>{this.state.searchTerm}</span><span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                }
                {this.state.caseSuggestions.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item.display_text}
                        label={item.display_text}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        <span className={'preserve-white-space'}>{item.display_text}</span><span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> ) : this.state.searchTerm.length > 0 ?
            <Select.OptGroup label={"No results found"}>
                <Select.Option
                    key={-1}
                    value={this.state.searchTerm}
                    label={this.state.searchTerm}
                    className='search-result-tag'
                    size='small'
                    type='tag'
                >
                    <span className={'preserve-white-space'}>{this.state.searchTerm}</span><span style={{float: "right", fontSize: 12}}></span>
                </Select.Option>
            </Select.OptGroup> : undefined;

        return (
            <ThemeProvider theme={morphleTheme1}>
                <CssBaseline />
                <div className={"full-parent"}>
                    <Spin tip="Loading..." spinning={this.props.isFetching} delay={500} wrapperClassName={'full-parent'}>
                        <div className={"full-parent"} ref={this.divFullParentRef}>
                            <Row className={"full-parent"}>
                                <Col span={24} offset={0} className="all-slides full-parent">
                                    <div ref={this.divHeaderRef}>
                                    <Row style={{ height: '50px' }}>
                                        <Col span={16}>
                                            <Row>
                                                <Col id={'case-view-search-select'} className={'custom-dropdown-max-height'} span={15} style={{display: 'flex'}}>
                                                    <Select
                                                        showSearch
                                                        placeholder={"Search by Folder / Patient Name"}
                                                        id="search-bar-case"
                                                        showArrow={false}
                                                        filterOption={false}
                                                        notFoundContent={null}
                                                        onSearch={this.performCaseSearch}
                                                        onSelect={this.onInputChange}
                                                        optionLabelProp="label"
                                                        value={this.state.searchTerm === "" ? undefined : <span className={'preserve-white-space'}>{this.state.searchTerm}</span>}
                                                        getPopupContainer={() => document.getElementById('case-view-search-select')}
                                                        style={{
                                                            width: "100%",
                                                            fontSize: "14px",
                                                            marginBottom: 0,
                                                            marginRight: !(this.state.searchTerm.length > 0) ? '-30px' : '-80px',
                                                            overflowY: 'auto',
                                                        }}
                                                    >
                                                        {caseSuggestionsBox}
                                                    </Select>
                                                    <Button
                                                        style={{ border: 0, fontSize: 20 }}
                                                        type="danger"
                                                        ghost
                                                        size="medium"
                                                        hidden={!(this.state.searchTerm.length > 0)}
                                                        onClick={this.clearSearch}
                                                    >
                                                        <CloseCircleOutlined />
                                                    </Button>
                                                    <Button style={{
                                                        background: 'transparent',
                                                        border: 0,
                                                        top: '1.5px',
                                                        padding: 0,
                                                        margin: 0,
                                                        visibility: !this.isMobile ? 'visible' : 'hidden'
                                                    }} title="Search options" onClick={this.handleFilterPane}>
                                                        <TuneIcon/>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: 15 }}>
                                                <Col span={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                    {this.getFilterTags()}
                                                </Col>
                                                <Col offset={0} span={3}
                                                    style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <MuiButton sx={{
                                                        visibility: !this.isMobile ? 'visible' : 'hidden',
                                                        fontSize: 10,
                                                        paddingY: 0.25
                                                    }}
                                                        variant={"outlined"} color={"buttonSecondary"}
                                                        size={"small"}
                                                        hidden={!this.state.filtersApplied}
                                                        onClick={this.onSeachReset}>
                                                        Clear Filters
                                                    </MuiButton>
                                                </Col>

                                            </Row>
                                        </Col>
                                        <Col span={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {hasPermissions([aclPermissions.export_cases_as_pdf]) ?
                                                <MuiButton onClick={this.fetchCases} variant={"outlined"}
                                                    color={"buttonSecondary"}
                                                    size={"small"}
                                                    endIcon={<DownloadOutlined />}>
                                                    Download Summary
                                                </MuiButton> : undefined}
                                        </Col>
                                        <Col span={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <MuiButton onClick={this.openAddNewCase} variant={"outlined"}
                                                color={"buttonSecondary"}
                                                size={"small"}
                                                endIcon={<PlusOutlined />}
                                                disabled={!hasPermissions([aclPermissions.create_case])}
                                            >
                                                Create New Case
                                            </MuiButton>
                                        </Col>
                                    </Row>
                                    </div>
                                    <div ref={this.divBodyRef}>
                                    <Row style={{ marginTop: 25, marginBottom: 10, height: "100%" }}>
                                            <div ref={this.selectOrderingRef}>
                                            {(this.state.selectedRowKeys.length > 0) ? this.getRowActionsIfAtleastOneRowSelected() :
                                                <Row>
                                                    <Col span={12}>
                                                        <Col style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                            <Select
                                                                value={this.props.urlState.ordering}
                                                                placeholder="Sort List"
                                                                onChange={this.handleSortChange}
                                                                style={{ width: 160 }}
                                                            >
                                                                <Option value="case_id">
                                                                    Name Ascending
                                                                </Option>
                                                                <Option value="-case_id">
                                                                    Name Descending
                                                                </Option>
                                                                <Option value="date">
                                                                    Oldest First
                                                                </Option>
                                                                <Option value="-date">
                                                                    Recent First
                                                                </Option>
                                                                <Option value="priority">
                                                                    Priority
                                                                </Option>
                                                                <Option value="case_status__status">
                                                                    Status New First
                                                                </Option>
                                                                <Option value="unread_first_everything_else">
                                                                    Unread First
                                                                </Option>
                                                            </Select>
                                                        </Col>
                                                    </Col>
                                                    <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        {!this.props.urlState?.ordering === "unread_first_everything_else" && this.getPaginationDiv()}
                                                    </Col>
                                                </Row>}
                                            </div>
                                            {this.props.urlState?.ordering === "unread_first_everything_else" &&
                                                <div>
                                                    <h3 ref={this.unreadTableHeadingRef}>
                                                    <button
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '5px 20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        border: 'none',
                                                        background: 'none',
                                                        margin: 3,
                                                        marginTop: 5,
                                                    }}
                                                    onClick={this.handleToggleUnreadTableCollapse}
                                                    >
                                                    <div style={{ fontSize: '10px', padding: 4 }}>
                                                        {this.state.isUnreadTableCollapsed ? <DownOutlined /> : <UpOutlined />}
                                                    </div>
                                                    <span style={{ marginLeft: 15 }}>
                                                        Unread
                                                    </span>
                                                    <Tooltip title={
                                                        <div style={{ padding: '10px', maxWidth: '200px' }}>
                                                        <ul style={{ margin: 0, paddingInlineStart: '20px' }}>
                                                        <li>Preview up to 5 cases awaiting pathologist review.</li>
                                                        <li>Organized from oldest to newest based on last update.</li>
                                                        <li>Last Update: Marks the addition of a new slide to a case  </li>
                                                        <li>Easily switch your role to pathologist in "Manage Users" section</li>
                                                        </ul>
                                                    </div>}
                                                        placement="right"
                                                    >
                                                        <InfoCircleOutlined style={{
                                                            fontSize: '14px',
                                                            cursor: 'pointer',
                                                            color: '#007bff',
                                                            marginLeft: 10
                                                        }}/>
                                                    </Tooltip>
                                                    </button>

                                                    </h3>

                                                    {!this.state.isUnreadTableCollapsed && (
                                                        <>
                                                        {unreadFirstDataTable.length === 0 ? (
                                                          <div
                                                            style={{
                                                                width: '98%',
                                                                margin: '0 auto',
                                                                height: '50px',
                                                                textAlign: 'center',
                                                                lineHeight: '50px',
                                                                color: '#666',
                                                                borderWidth: '80%',
                                                                borderTop: '1px solid #ddd',
                                                                borderBottom: '1px solid #ddd',


                                                            }}
                                                          >
                                                            You are all caught up
                                                          </div>
                                                        ) : (
                                                          <Table
                                                            bordered={false}
                                                            className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                                                            rowClassName={(record, index) => (record.unread ? 'slide-table-rows unread' : 'slide-table-rows read')}
                                                            columns={unreadFirstColumns}
                                                            dataSource={unreadFirstDataTable}
                                                            pagination={false}
                                                            onRow={onRow}
                                                            locale={{ emptyText: (<Empty description="No Cases Found" />) }}
                                                            rowSelection={rowSelection}
                                                            size="small"
                                                          />
                                                        )}
                                                      </>
                                                        )
                                                    }
                                                </div>
                                            }
                                            {this.props.urlState?.ordering === "unread_first_everything_else" &&
                                                <h3 ref={this.everythingElseTableHeadingRef}>
                                                <button
                                                style={{
                                                    cursor: 'pointer',
                                                    padding: '5px 20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    border: 'none',
                                                    background: 'none',
                                                    margin: 3,
                                                    marginTop: 5 ,
                                                }}
                                                onClick={this.handleToggleEverythingElseTableCollapse}
                                                >
                                                    <div style={{ fontSize: '10px', padding: 4 }}>
                                                        {this.state.isEverythingElseTableCollapsed ? <DownOutlined /> : <UpOutlined />}
                                                    </div>
                                                    <span style={{ marginLeft: 15 }}>
                                                        Everything Else
                                                    </span>
                                                    <Tooltip title={
                                                        <div style={{ padding: '10px', maxWidth: '200px' }}>
                                                        <ul style={{ margin: 0, paddingInlineStart: '20px' }}>
                                                            <li>View all cases not in the "Unread" section.</li>
                                                            <li>Sorted by most recent updates for quick access.</li>
                                                        </ul>
                                                        </div>}
                                                    placement="right">
                                                        <InfoCircleOutlined style={{
                                                            fontSize: '14px',
                                                            cursor: 'pointer',
                                                            color: '#007bff',
                                                            marginLeft: 10,}}/>
                                                    </Tooltip>
                                                </button>
                                                </h3>
                                            }
                                        {!(this.state.isEverythingElseTableCollapsed && this.props.urlState?.ordering === "unread_first_everything_else") && (
                                            <Table
                                                bordered={false}
                                                className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                                                rowClassName={(record, index) => (record.unread ? 'slide-table-rows  unread' : 'slide-table-rows read')}
                                                columns={columns}
                                                dataSource={data}
                                                pagination={false}
                                                onRow={onRow}
                                                locale={{ emptyText: (<Empty description="No Cases Found" />) }}
                                                rowSelection={rowSelection}
                                                size="small"
                                            />
                                        )}
                                    </Row>
                                    </div>
                                    <div ref={this.divPaginationRef}>
                                    <Row>
                                        {this.getPaginationDiv()}
                                    </Row>
                                    </div>
                                </Col>
                            </Row>
                            {this.state.anchorEl ?
                                <FilterComp anchorEl={this.state.anchorEl} onClose={this.onCaseFilterClose}
                                    width={this.searchBarWidth} /> : null}
                        </div>
                    </Spin>
                    {this.props.caseModalOpen ? <ShareModal type={openInNewTabType.CASE} assign={true}
                        caseRefreshProps={this.caseRefreshProps} /> : null}
                </div>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        allCases: state.casesReducer,
        allCaseStatus: state.caseStatusReducer.case_status,
        casePriorities: state.caseStatusReducer.case_priority,
        allUsers: state.caseStatusReducer.users,
        numPages: state.caseStatusReducer.numPages,
        pageNumber: state.caseStatusReducer.pageNumber,
        total: state.caseStatusReducer.total,
        urlState: state.searchCaseReducer,
        isFetching: state.searchCaseReducer.isFetching,
        caseModalOpen: state.shareManagerReducer.caseModalOpen,
        caseOrder: state.morpheusSettingReducer.sorting?.case_order_by,
        caseViewFilter: state.morpheusSettingReducer.case_view_filter
    };
};

export default connect(mapStateToProps)(CasesView);
